module.exports = __webpack_public_path__ + "static/media/bg.1a6a2dc3.jpg";